import en from "./en";
import es from "./es";
import pt from "./pt";

export const translations = { en, es, pt };
